import ActivityBanner from "@/components/ActivityBanner";
import HBIcon from "@/components/HBIcon";
import { useLogin } from "@/components/LoginModal";
import { MaterialAuthTable } from "@/components/MaterialAuthTable";
import { VipInfoAuth } from "@/components/MaterialAuthTable/authService";
import Question from "@/components/Question";
import { BuyVipDialog } from "@/components/Vip";
import useAppStore from "@/context/store";
import { checkUserGroup } from "@/services";
import { isGdMerged } from "@/utils/gaoding";
import { useGdInfo } from "@/utils/hooks/useGdInfo";
import { gaodingEditHost } from "@/utils/host";
import { openUdesk } from "@/utils/initUdesk";
import { cacheor } from "@/utils/server/cacheor";
import { serverSideRedirect } from "@/utils/server/serverSide";
import { Popover } from "antd";
import classNames from "classnames";
import { flatten } from "lodash";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Else, If, Then, When } from "react-if";
import styles from "./index.module.less";

function VipInfoQuestion({ data }) {
  return (
    <div className={styles.question}>
      <Question
        questionTitle={data?.questionTitle}
        question={data?.question}
        questionMoreText={data?.questionMoreText}
        questionMoreLink={data?.questionMoreLink}
      ></Question>
    </div>
  );
}

function VipInfoBenefit({ data }) {
  return (
    <div className={styles.benefit}>
      <div className={styles.header}>{data?.benefitTitle}</div>
      <div className={styles.container}>
        <div className={styles.top}>
          {data?.benefitTop?.map((item, index) => (
            <div className={styles.card} key={index}>
              <div className={styles.line}>
                <When condition={item?.logo?.length > 0}>
                  <div className={styles.logo}>
                    <img src={item?.logo[0]?.url} alt="利益点图标" />
                  </div>
                </When>
                <div className={styles.title}>{item.title}</div>
              </div>
              <ul className={styles.list}>
                {item?.list?.map((item, index) => (
                  <li key={index}>
                    <div
                      className={styles.text}
                      dangerouslySetInnerHTML={{ __html: item.text }}
                    ></div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className={styles.bottom}>
          {data?.benefitBottom?.map((item, index) => (
            <div className={styles.card} key={index}>
              <When condition={item?.logo?.length > 0}>
                <div className={styles.logo}>
                  <img src={item?.logo[0]?.url} alt="利益点图标" />
                </div>
              </When>
              <div className={styles.title}>{item.title}</div>
              <div className={styles.subtitle}>{item.subtitle}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function VipInfoBuy({ data }) {
  const user = useAppStore((s) => s.user);
  const { login } = useLogin();

  const onClick = useCallback(
    (item) => {
      if (item.buttonClick === "consult") {
        window.open("/vip/consult");
        return;
      }

      if (!user) {
        login();
        return;
      }

      if (item.buttonClick === "udesk") {
        openUdesk();
        return;
      }

      if (user?.extra?.material_vip === 30) {
        window.open("/me/right");
      } else {
        if (item.buttonClick === "personalNoAuth") {
          BuyVipDialog.open({
            type: "personal",
            versionTab: 1,
          });
        } else {
          BuyVipDialog.open({
            type: item.buttonClick,
          });
        }
      }
    },
    [login, user]
  );

  return (
    <div className={styles.buy} style={{ "--main-color": data?.buyColor }}>
      {data?.buy?.map((item, index) => (
        <div className={styles.card} key={index}>
          <When condition={item?.label?.length > 0}>
            <img
              className={styles.label}
              src={item?.label && item?.label[0]?.url}
              alt="标签"
            />
          </When>
          <div className={styles.title}>{item.title}</div>
          <div className={styles.subtitle}>
            <div className={styles.text}>{item.subtitle}</div>
            <When condition={item.subtitleTip}>
              <Popover
                content={
                  <div
                    className={styles.tipText}
                    dangerouslySetInnerHTML={{ __html: item.subtitleTip }}
                  ></div>
                }
                overlayStyle={{ width: 348 }}
                placement="bottom"
              >
                <HBIcon className={styles.icon} type="ic_help" />
              </Popover>
            </When>
          </div>
          <div className={styles.price}>
            <If condition={item?.isPrice}>
              <Then>
                <div className={styles.yuan}>￥</div>
                <div className={styles.num}>{item?.price}</div>
                <div className={styles.unit}>{item?.unit}</div>
              </Then>
              <Else>
                <div className={styles.priceText}>{item?.priceText}</div>
              </Else>
            </If>
          </div>
          <div
            className={classNames([
              styles.button,
              item?.buttonType === "text" ? styles.line : null,
            ])}
            onClick={() => onClick(item)}
            data-gd-click="button_click"
            data-button-name={`${item?.title}-${item?.buttonText}`}
          >
            {item?.buttonText}
          </div>
          <ul className={styles.desc}>
            {item?.list?.map((item, index) => (
              <li key={index}>
                <div className={styles.text}>{item.text}</div>
                <When condition={item.tip}>
                  <Popover
                    content={
                      <div
                        className={styles.tipText}
                        dangerouslySetInnerHTML={{ __html: item.tip }}
                      ></div>
                    }
                    placement="bottom"
                  >
                    <HBIcon className={styles.icon} type="ic_help" />
                  </Popover>
                </When>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

export async function getServerSideProps({ query, req, res }) {
  const user = req.user;
  if (isGdMerged(user)) {
    return serverSideRedirect(res, {
      destination: `https://${gaodingEditHost}/pricing?from=gdmaterial`,
    });
  }

  const result = await cacheor.getGrocery({
    path: "vip-info",
    disableCache: query?._cache,
  });

  if (result.cardsByGroup?.length > 0) {
    const group_ids = flatten(result.cardsByGroup.map((item) => item.groupIds));

    const groupIdMap = await checkUserGroup({
      group_ids,
      cookie: req.headers.cookie,
    });

    // 用户分群对应的展示策略
    const matched = result.cardsByGroup.find((item) =>
      item.groupIds.some((id) => groupIdMap[id])
    );

    if (matched) {
      return {
        props: {
          data: {
            ...result,
            ...matched,
          },
        },
      };
    }
  }

  return {
    props: {
      data: result,
    },
  };
}

export default function VipInfoPage({ data }) {
  const user = useAppStore((s) => s.user);

  const { login } = useLogin();
  // 给table加ID
  data?.auth?.forEach((item, i) => {
    item?.list?.forEach((data, j) => {
      data.id = `${i}-${j}`;
    });
  });
  data?.authList?.forEach((item, i) => {
    item.id = i;
  });

  useEffect(() => {
    window._showUdesk = () => {
      openUdesk();
    };
  }, [login, user]);

  // 活动banner（倒计时）是否结束
  const [isEnd, setIsEnd] = useState(false);

  const activityBanner = useMemo(() => {
    // 判断是否有倒计时
    const banner = data?.activityBanner;

    const targetDate = banner?.countDown?.targetDate;

    if (targetDate) {
      // 计算倒计时有没有结束
      const isEnd = targetDate - Date.now() <= 0;
      if (isEnd) {
        return null;
      }
    }

    return {
      ...banner,
      countDown: {
        ...(banner?.countDown || null),
        onEnd: () => {
          setIsEnd(true);
        },
      },
    };
  }, [data?.activityBanner]);

  const { isGdMerged } = useGdInfo();
  const router = useRouter();
  useEffect(() => {
    if (isGdMerged) {
      router.push(`https://${gaodingEditHost}/pricing?from=gdmaterial`);
    }
  }, [isGdMerged, router]);

  return (
    <div className={classNames(styles.info, styles.hideVipBuy)}>
      <h1 style={{ display: "none" }}>花瓣素材会员介绍</h1>
      {activityBanner?.background?.length > 0 && !isEnd ? (
        <ActivityBanner {...activityBanner} />
      ) : (
        <div className={styles.banner}>
          <img
            className={styles.back}
            src={data?.header?.background[0]?.url}
            alt="花瓣素材背景图"
          />
          <img
            className={styles.front}
            src="https://grocery-cdn.huaban.com/file/83259130d32611efaadd17477f0bb4b9.svg"
            alt="花瓣素材前景图"
            width={322}
            height={36}
          />
        </div>
      )}
      <div className={styles.wrapper}>
        <VipInfoBenefit data={data} />
        <MaterialAuthTable className={styles.auth} data={data} />
        <VipInfoAuth data={data} />
        <VipInfoQuestion data={data} />
      </div>
    </div>
  );
}
